import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../../../security/auth/authentication.service';

/**
 * When the session token has expired the API answers 401 and every page just rendered
 * empty (the Profile page with no data was the visible symptom). Log the user out and
 * send them to the login page, remembering where they were.
 */
@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  constructor(private auth: AuthenticationService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: unknown) => {
        const isAuthCall = /\/(auth|login|external\/auth|codeVerification|createPassword|resetPassword)/i.test(req.url);
        if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403) && !isAuthCall && this.auth.getToken()) {
          this.auth.logout();
          this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url, reason: 'expired' } });
        }
        return throwError(() => err);
      })
    );
  }
}
